import { NewsletterBand } from "../components/Sections";
import { StandardPage } from "../components/PageContent";
import { sharedContent } from "../content/siteContent";
import { aboutPage, productsPage, servicesPage } from "../content/pagesContent";

const newsletter = <NewsletterBand content={sharedContent.newsletter} />;

export function ServicesPage() {
  return <StandardPage page={servicesPage} newsletter={newsletter} />;
}

export function ProductsPage() {
  return <StandardPage page={productsPage} newsletter={newsletter} />;
}

export function AboutPage() {
  return <StandardPage page={aboutPage} newsletter={newsletter} />;
}
